export const timeAgo = (timestamp) => {
  const now = new Date();
  const past = new Date(timestamp);
  const secondsPast = (now - past) / 1000;

  if (secondsPast < 60) {
    return `${Math.floor(secondsPast)} seconds ago`;
  }
  if (secondsPast < 3600) {
    const minutes = Math.floor(secondsPast / 60);
    return minutes === 1 ? "1 minute ago" : `${minutes} minutes ago`;
  }
  if (secondsPast < 86400) {
    const hours = Math.floor(secondsPast / 3600);
    return hours === 1 ? "1 hour ago" : `${hours} hours ago`;
  }
  if (secondsPast < 604800) {
    const days = Math.floor(secondsPast / 86400);
    return days === 1 ? "1 day ago" : `${days} days ago`;
  }
  if (secondsPast < 2419200) {
    // Less than 4 weeks
    const weeks = Math.floor(secondsPast / 604800);
    return weeks === 1 ? "1 week ago" : `${weeks} weeks ago`;
  }
  if (secondsPast < 31536000) {
    // Less than 1 year
    const months = Math.floor(secondsPast / 2419200);
    return months === 1 ? "1 month ago" : `${months} months ago`;
  }

  const years = Math.floor(secondsPast / 31536000);
  return years === 1 ? "1 year ago" : `${years} years ago`;
};
